export const USA_VOTING = "The political power you need to create the future that you want.";
export const EMPOWERING = "Common Sense for Uniting America";
export const AFFILIATED_LINK = "AFFILIATED GROUPS";
